import Tooltip from '../ui/Tooltip';

interface InputCheckboxTypes {
	label: string;
	labelAdditionlInfo?: string;
	id: string;
	isChecked: boolean;
	parentClass?: string;
	tooltip?: string;
	handleChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
}
const InputCheckbox = ({
	id,
	isChecked,
	label,
	labelAdditionlInfo,
	parentClass = 'relative flex items-start my-4',
	handleChange,
	tooltip
}: InputCheckboxTypes) => {
	return (
		<div className={parentClass}>
			<div className='flex h-6 items-center'>
				<input
					aria-describedby='comments-description'
					checked={isChecked}
					className='h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-600 hover:cursor-pointer'
					id={id}
					name='comments'
					type='checkbox'
					onChange={(e) => handleChange(e)}
				/>
			</div>
			<div className='flex ml-3 text-sm leading-6'>
				<label className='font-medium text-gray-800 mr-2' htmlFor={id}>
					{label}
				</label>
				{labelAdditionlInfo !== undefined && (
					<span className='text-gray-500 mr-2' id='comments-description'>
						<span className='sr-only'>{label} </span> {labelAdditionlInfo}
					</span>
				)}
				{tooltip !== undefined && <Tooltip message={tooltip} />}
			</div>
		</div>
	);
};
export default InputCheckbox;
